import * as React from 'react';
import { InputLabel, TextField } from '@mui/material';
import styled from '@emotion/styled';
import { TextFieldInputProps } from '../Filter.interface';
import { FilterChildNameSharedStyle, FilterChildSharedStyle, TableContainerStyle } from '../Filter.mock';

const TableContainer = styled.div(TableContainerStyle, FilterChildSharedStyle);

const TextFieldInput = ({ groupName, placeHolder, checkedEntity, onChangeHandler, isValid = true }: TextFieldInputProps) => {
  const onHandlePostalCodeInputChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const userInput = e.target.value;

      onChangeHandler(userInput);
    },
    [onChangeHandler]
  );

  return (
    <TableContainer>
      <InputLabel sx={FilterChildNameSharedStyle}>
        <b>{groupName}</b>
      </InputLabel>
      <TextField
        size="small"
        sx={{ width: '100%', bgcolor: '#ffffff', borderRadius: '5px' }}
        name={groupName}
        placeholder={placeHolder ?? groupName}
        value={checkedEntity}
        onChange={onHandlePostalCodeInputChange}
        error={!!checkedEntity[0] && !isValid}
      />
    </TableContainer>
  );
};

export default TextFieldInput;
